(() => {
  const mobileQuery = window.matchMedia('(max-width: 599px)');

  const initMobileProductBar = () => {
    if (!mobileQuery.matches) return;

    document.querySelectorAll('[data-lcpp-root]').forEach((root) => {
      if (root.querySelector('[data-lcpp-mobilebar]')) return;

      const addButton = root.querySelector('[data-lcpp-add]');
      const addLabel = root.querySelector('[data-lcpp-add-label]');
      const price = root.querySelector('[data-lcpp-price]');
      const stock = root.querySelector('[data-lcpp-stock]');
      const variantSelect = root.querySelector('[data-lcpp-variant-select]');

      let labels = {};
      try { labels = JSON.parse(root.querySelector('[data-lcpp-labels]')?.textContent || '{}'); } catch (_) { labels = {}; }

      if (!addButton || !price) return;

      const bar = document.createElement('div');
      bar.className = 'lcpp-mobilebar';
      bar.dataset.lcppMobilebar = '';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = `
        <div class="lcpp-mobilebar__inner">
          <div class="lcpp-mobilebar__meta">
            <span>${labels.orderNow || 'Nu bestellen'}</span>
            <strong data-lcpp-mobile-price></strong>
            <div class="lcpp-mobilebar__stock" data-lcpp-mobile-stock><i></i><span></span></div>
          </div>
          <button type="button" data-lcpp-mobile-add>
            <span data-lcpp-mobile-add-label></span>
          </button>
        </div>`;

      root.appendChild(bar);

      const mobilePrice = bar.querySelector('[data-lcpp-mobile-price]');
      const mobileStock = bar.querySelector('[data-lcpp-mobile-stock]');
      const mobileStockLabel = mobileStock?.querySelector('span');
      const mobileAdd = bar.querySelector('[data-lcpp-mobile-add]');
      const mobileAddLabel = bar.querySelector('[data-lcpp-mobile-add-label]');

      const sync = () => {
        mobilePrice.textContent = price.textContent.trim();
        mobileAdd.disabled = addButton.disabled;
        mobileAddLabel.textContent = addLabel?.textContent?.trim() || (addButton.disabled ? (labels.addSoldOut || 'Uitverkocht') : (labels.addAvailable || 'In winkelwagen'));

        if (mobileStock) {
          const isOut = stock ? stock.classList.contains('is-out') : addButton.disabled;
          mobileStock.classList.toggle('is-out', isOut);
          if (mobileStockLabel) {
            const sourceLabel = stock?.querySelector('span')?.textContent?.trim();
            mobileStockLabel.textContent = sourceLabel || (isOut ? (labels.stockSoldOut || 'Tijdelijk uitverkocht') : (labels.stockAvailable || 'Op voorraad en bestelbaar'));
          }
        }
      };

      mobileAdd.addEventListener('click', () => {
        if (addButton.disabled) return;
        const form = addButton.closest('form');
        if (form && typeof form.requestSubmit === 'function') {
          form.requestSubmit(addButton);
        } else {
          addButton.click();
        }
      });

      if (variantSelect) {
        variantSelect.addEventListener('change', () => window.requestAnimationFrame(sync));
      }

      const observer = new MutationObserver(sync);
      observer.observe(price, { childList: true, subtree: true, characterData: true });
      observer.observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
      if (addLabel) observer.observe(addLabel, { childList: true, subtree: true, characterData: true });
      if (stock) {
        observer.observe(stock, { attributes: true, attributeFilter: ['class'] });
        const stockLabel = stock.querySelector('span');
        if (stockLabel) observer.observe(stockLabel, { childList: true, subtree: true, characterData: true });
      }

      if ('IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver((entries) => {
          const shouldShow = !entries[0].isIntersecting;
          bar.classList.toggle('is-visible', shouldShow);
          bar.setAttribute('aria-hidden', String(!shouldShow));
        }, { threshold: 0.15 });
        visibilityObserver.observe(addButton);
      } else {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      }

      sync();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductBar, { once: true });
  } else {
    initMobileProductBar();
  }
})();
